const FormResources = 
{
    form_data_project_assignment:
    {
        project_id: '',
        supervisor_copy: false,
        format: 'portrait'
    },

    form_data_next_scheduled_projects:
    {
        building_id: [],
        level_id: [],
        area_id: [],
        task_id: [],
        date_range: {startDate: '', endDate: ''},
        show_rooms_never_completed: false,
        format: 'portrait'
    },

    form_data_project_completion_room:
    {
        date_range: {startDate: '', endDate: ''},
    },

    form_format_project_assignment: [
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project:',
            model_name: 'project_id',
            ref:        'project_id_input',
            ref_alt:    'project_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor copy:',
            model_name: 'supervisor_copy',
            ref:        'supervisor_copy_input',
            ref_alt:    'supervisor_copy_input_alt',
            required:   false,
        },
    ],

    form_format_next_scheduled_projects: [
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select building(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select level(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select area(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select task(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'date-picker',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date Range:',
            model_name: 'date_range',
            ref:        'date_range_input',
            ref_alt:    'date_range_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Show rooms never completed:',
            model_name: 'show_rooms_never_completed',
            ref:        'show_rooms_never_completed_input',
            ref_alt:    'show_rooms_never_completed_input_alt',
            required:   false,
        },
    ]
}

export default FormResources;